var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainCoroporate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3327 15.1669C23.3327 21.0002 19.2493 23.9169 14.396 25.6085C14.1419 25.6947 13.8658 25.6905 13.6143 25.5969C8.74935 23.9169 4.66602 21.0002 4.66602 15.1669V7.0002C4.66602 6.69078 4.78893 6.39403 5.00772 6.17524C5.22652 5.95645 5.52326 5.83353 5.83268 5.83353C8.16602 5.83353 11.0827 4.43353 13.1127 2.6602C13.3598 2.44903 13.6743 2.33301 13.9993 2.33301C14.3244 2.33301 14.6389 2.44903 14.886 2.6602C16.9277 4.4452 19.8327 5.83353 22.166 5.83353C22.4754 5.83353 22.7722 5.95645 22.991 6.17524C23.2098 6.39403 23.3327 6.69078 23.3327 7.0002V15.1669Z",
    stroke: "#0066CC",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainCoroporate);
export default __webpack_public_path__ + "static/media/mainCoroporate.29dd3725adc3f781a185ad4ff11bba84.svg";
export { ForwardRef as ReactComponent };